<template>
  <section>
    <div class="login-container">
      <div class="login-box">
        <h1 class="login-title">Acesse sua conta</h1>
        <div v-if="errorMessage" class="snackbar error top">
          {{ errorMessage }}
        </div>
        <div v-if="successMessage" class="snackbar success top">
          {{ successMessage }}
        </div>
        <form @submit.prevent="login">
          <div class="input-group">
            <label for="email">E-mail:</label>
            <input
              type="email"
              id="email"
              v-model="username"
              :class="{ 'input-error': emailError }"
              placeholder="exemplo@gmail.com"
            />
            <p v-if="emailError" class="field-error">{{ emailError }}</p>
          </div>

          <div class="input-group">
            <label for="password">Senha:</label>
            <input
              type="password"
              id="password"
              v-model="password"
              :class="{ 'input-error': passwordError }"
              placeholder="Insira sua senha"
            />
            <p v-if="passwordError" class="field-error">{{ passwordError }}</p>
          </div>

          <button type="submit" class="login-button">Continuar</button>
        </form>

        <p class="register-text">
          Ainda não possui conta?
          <a class="register-link" href="/register">Criar agora</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginCard",
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
      successMessage: "",
      emailError: "", // <--- ADICIONADO
      passwordError: "", // <--- ADICIONADO
    };
  },
  methods: {
    ...mapActions(["loginUser"]),

    validarEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    async login() {
      this.emailError = "";
      this.passwordError = "";

      let hasError = false;

      if (!this.username) {
        this.emailError = "O e-mail é obrigatório.";
        hasError = true;
      } else if (!this.validarEmail(this.username)) {
        this.emailError = "E-mail inválido.";
        hasError = true;
      }

      if (!this.password) {
        this.passwordError = "A senha é obrigatória.";
        hasError = true;
      } else if (this.password.length < 8) {
        this.passwordError = "A senha deve ter no mínimo 8 caracteres.";
        hasError = true;
      }

      if (hasError) {
        this.errorMessage = "Preencha os campos corretamente.";
        return;
      }

      try {
        const response = await this.loginUser({
          username: this.username,
          password: this.password,
        });

        if (response && response.success === false) {
          this.errorMessage = "E-mail ou Senha incorretos";
          this.successMessage = "";
        } else {
          this.successMessage = "Login bem-sucedido!";
          this.errorMessage = "";

          setTimeout(() => {
            this.$router.push("/");
          }, 500);
        }
      } catch (error) {
        console.error("Erro inesperado ao fazer login:", error);
        this.errorMessage = "Erro inesperado. Tente novamente mais tarde.";
        this.successMessage = "";
      }
    },
  },

  watch: {
    username(value) {
      if (!value) {
        this.emailError = "O e-mail é obrigatório.";
      } else if (!this.validarEmail(value)) {
        this.emailError = "E-mail inválido.";
      } else {
        this.emailError = "";
      }
    },
    password(value) {
      if (!value) {
        this.passwordError = "A senha é obrigatória.";
      } else if (value.length < 8) {
        this.passwordError = "A senha deve ter no mínimo 8 caracteres.";
      } else {
        this.passwordError = "";
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--terracota); /* Cor laranja */
  position: relative; /* Para posicionar o snackbar na parte inferior */
}

.login-box {
  background-color: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.login-title {
  color: black; /* Título em preto */
  font-family: "Roboto Slab", sans-serif;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  color: black;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.input-group input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 50px;
  color: #333; /* Cor do texto do input */
  background-color: white; /* Certifique-se de que o fundo seja branco */
}

/* Estiliza o placeholder */
.input-group input::placeholder {
  color: #888; /* Cor do placeholder */
}

.login-button {
  background-color: var(--terracota);
  color: white;
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  padding: 10px;
  border: none;
  border-radius: 25px; /* Mais arredondado */
  cursor: pointer;
  width: 100%;
}

.login-button:hover {
  background-color: #d45f3e; /* Um tom mais escuro do laranja para hover */
}

.snackbar {
  padding: 10px;
  border-radius: 5px;
  text-align: center;

  font-family: "Rubik", sans-serif;
  margin-bottom: 20px;
}

.snackbar.success {
  background-color: rgba(112, 255, 112, 0.5);
  color: rgb(58, 133, 58);
}

.snackbar.error {
  background-color: rgba(255, 112, 112, 0.5);
  color: rgb(133, 58, 58);
}

.register-text {
  text-align: center;
  margin-top: 10px;
  color: black; /* Cor do texto "Ainda não possui conta?" em preto */
}

.register-link {
  color: var(--terracota); /* Cor do link "Criar agora" */
  cursor: pointer;
}
.input-error {
  border: 1px solid #f44336;
}

.field-error {
  color: #f44336;
  font-size: 0.85em;
  margin-top: 5px;
}
</style>
